<template>
    <div id="containerDailyCost">
        <svg :style="{'width': svg.width, 'height': svg.height}">
            <!-- yAxis -->
            <g v-for="(y, yIdx) in yAxisList" :key="'y' + yIdx">
                <template v-if="!isNaN(yScale(Math.round(y * 100) / 100))">
                    <text
                        font-size="12"
                        text-anchor="end"
                        :y="yScale(Math.round(y * 100 ) / 100) + 4"
                        :x="svg.paddingL - 3"
                        :fill="themeColors.primary"
                    >
                        {{ __toKFormat(y) }}
                    </text>
                    <line
                        v-if="datesOfThisMonth.length"
                        style="stroke-width:0.5"
                        opacity="0.3"
                        :stroke="theme === 'light' ? themeColors.dark : themeColors.light"
                        :x1="svg.paddingL - 1"
                        :x2="svg.width - svg.paddingR - (svg.width - svg.paddingL) / datesOfThisMonth.length / 2 + 3"
                        :y1="yScale(Math.round(y * 100) / 100)"
                        :y2="yScale(Math.round(y * 100) / 100)"
                    />
                </template>
            </g>
            <!-- yAxis - Right -->
            <g v-for="(y, yIdx) in [0, maxCumaltaiveCost]" :key="'yr' + yIdx">
                <text
                    v-if="!isNaN(yCumaltiveScale(y))"
                    text-anchor="start"
                    font-size="12"
                    :fill="themeColors.warning"
                    :x="svg.width - svg.paddingR"
                    :y="yCumaltiveScale(y) + 4"
                >
                    {{__toKFormat(y)}}
                </text>
                <line
                    v-if="datesOfThisMonth.length"
                    style="stroke-width:0.5"
                    :stroke="themeColors.warning"
                    :x1="svg.width - svg.paddingR"
                    :x2="svg.width - svg.paddingR - (svg.width - svg.paddingL)/datesOfThisMonth.length/2"
                    :y1="yCumaltiveScale(Math.round(y * 100) / 100)"
                    :y2="yCumaltiveScale(Math.round(y * 100) / 100)"
                />
            </g>
            <!-- xAxis -->
            <g v-for="(x, xIdx) in datesOfThisMonth" :key="'x' + xIdx">
                <text
                    :y="svg.height - svg.paddingB + 14"
                    :x="xScale(x) + (svg.width - svg.paddingL)/datesOfThisMonth.length/2"
                    :fill="theme === 'light' ? themeColors.dark : themeColors.light"
                    text-anchor="middle"
                    font-size="12"
                >
                    {{ formattedDate(lang, x, 'day') }}
                </text>
                <line
                    :x1="xScale(x) + (svg.width - svg.paddingL)/datesOfThisMonth.length/2"
                    :x2="xScale(x) + (svg.width - svg.paddingL)/datesOfThisMonth.length/2"
                    :y1="0"
                    :y2="svg.height - svg.paddingB + 4"
                    :stroke="theme === 'light' ? themeColors.dark : themeColors.light"
                    opacity="0.2"
                    style="stroke-width:0.5"
                />
            </g>
            <!-- bars -->
            <g v-for="(date, dateIdx) in datesOfThisMonth" :key="'bar'+dateIdx">
                <transition-group name="list" appear tag="g">
                    <template v-for="(item, itemIdx) in dataWithCost.filter(item => item.date == date)">
                        <g :key="'rect' + projectIdx + month + dateIdx + itemIdx" v-if="status=='200'">
                            <rect
                                style="cursor:pointer"
                                :x="xScale(date) + xScale.bandwidth()/4"
                                :y="item.cost > 0 ? yScale(item.cost) : yScale(0)"
                                :fill="themeColors.primary"
                                opacity="0.3"
                                :height="Math.abs(yScale(0) - yScale(item.cost))"
                                :width="xScale.bandwidth()/2"
                                @mouseover="mouseoverDate(date)"
                                @mouseout="mouseoutDate"
                                @click="emitDetailLayer(date)"
                            />
                        </g>
                    </template>
                </transition-group>
            </g>
            <!-- line - cumaltive -->
            <g v-for="(item, itemIdx) in datesOfThisMonth" :key="'c' + itemIdx">
                <line
                    v-if="cumalativeCosts[itemIdx + 1]"
                    :x1="xScale(item) + (svg.width - svg.paddingL) / datesOfThisMonth.length / 2"
                    :x2="xScale(datesOfThisMonth[itemIdx + 1]) + (svg.width - svg.paddingL) / datesOfThisMonth.length / 2"
                    :y1="yCumaltiveScale(cumalativeCosts[itemIdx])"
                    :y2="yCumaltiveScale(cumalativeCosts[itemIdx + 1])"
                    :stroke="themeColors.warning"
                    style="stroke-width:1"
                />
                <circle
                    :cx="xScale(item) + (svg.width - svg.paddingL) / datesOfThisMonth.length / 2"
                    :cy="yCumaltiveScale(cumalativeCosts[itemIdx])"
                    :r="4"
                    :fill="themeColors.light"
                    :stroke="themeColors.warning"
                />
            </g>
            <!-- Layers -->
            <g v-for="(date, dateIdx) in datesOfThisMonth" :key="'layer'+dateIdx">
                <template v-for="(item, itemIdx) in dataWithCost.filter(item => item.date == date)">
                    <g :key="'rect'+dateIdx+itemIdx">
                        <g v-if="dateMouseover == date">
                            <rect
                                rx="5" ry="5"
                                :x="xScale(date) + (dateIdx < datesOfThisMonth.length / 2 ? xScale.bandwidth() * 5 / 4 : xScale.bandwidth() * 1 / 4 * -1 - 200)"
                                :y="svg.paddingT"
                                opacity="0.9"
                                :height="60 + Math.min(item.products.length, 5) * 16"
                                width="200"
                                :fill="themeColors[theme]"
                            />
                            <text
                                :x="xScale(date) + (dateIdx < datesOfThisMonth.length / 2 ? xScale.bandwidth() * 5 / 4 + 10 : xScale.bandwidth() * 1 / 4 * -1 - 10)"
                                :text-anchor="dateIdx < datesOfThisMonth.length / 2 ? 'start' :'end'"
                                :y="svg.paddingT + 20"
                                :fill="themeColors.currentColor"
                                font-weight="bold"
                                font-size="14"
                            >
                                {{item.date}}
                            </text>
                            <text
                                :x="xScale(date) + (dateIdx < datesOfThisMonth.length / 2 ? xScale.bandwidth() * 5 / 4 + 10 : xScale.bandwidth() * 1 / 4 * -1 - 10)"
                                :text-anchor="dateIdx < datesOfThisMonth.length / 2 ? 'start' :'end'"
                                :y="svg.paddingT + 45"
                                :fill="themeColors.primary"
                                font-weight="bold"
                                font-size="20"
                            >
                                {{$_getDollar(item.cost).replace(' ','')}}
                            </text>
                            <g v-for="(product, productIdx) in item.products" :key="'product' + productIdx">
                                <text
                                    v-if="productIdx < 5"
                                    :x="xScale(date) + (dateIdx < datesOfThisMonth.length / 2 ? xScale.bandwidth() * 5 / 4 + 10 : xScale.bandwidth() * 1 / 4 * -1 - 10)"
                                    :text-anchor="dateIdx < datesOfThisMonth.length / 2 ? 'start' :'end'"
                                    :y="svg.paddingT + 66 + productIdx * 16"
                                    font-size="13"
                                    :fill="product.cost > 0 ? themeColors.currentColor : themeColors.warning">
                                    {{product.productCode.replace('AWS','').replace('Amazon','')}} {{$_getDollar(product.cost).replace(' ','')}}
                                </text>
                            </g>
                        </g>
                    </g>
                </template>
            </g>
        </svg>
        <template v-if="costOfAfterThisMonth > 0">
            <p
                class="text-right mt-2 mb-0"
                :style="{'color': themeColors.warning}"
            >
                <small>
                    * {{ $t('org.billing.costNotExpressedInGraph').replace('{cost}', $_getDollar(costOfAfterThisMonth).replace(' ','')) }}
                </small>
            </p>
        </template>
    </div>
</template>

<script>
import { getCurrentInstance, inject, computed, toRefs, ref, onMounted, onUnmounted } from '@vue/composition-api'
import useCommonData from '@/composables/useCommonData'
import formattedDate from '@/utils/formattedDate'
export default {
    props: {
        mode: {
            type: String,
            default: null
        },
        svg: {
            type: Object,
            default: function () {
                return {}
            }
        },
        month: {
            type: String,
            default: ''
        },
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        status: {
            type: String,
            default: ''
        },
        projectIdx: {
            type: Number,
            default: null
        },
        dataWithCost: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const d3 = vm.$d3
        const { __toKFormat } = useCommonData()
        const { svg, data, month } = toRefs(props)
        const themeColors = inject('themeColors')
        const theme = inject('theme')
        const dateMouseover = ref(null)
        const productMouseover = ref(null)
        const lang = computed(() => vm.$i18n.locale)
        const dataOfThisMonth = computed(() => {
            return data.value.filter(item => item.date.indexOf(data.value.length ? data.value[0].date.substring(0, 7) : month.value) > -1)
        })
        const datesOfThisMonth = computed(() => {
            return dataOfThisMonth.value.map(item => item.date)
        })
        const maxDailyCost = computed(() => {
            return Math.max.apply(null, dataOfThisMonth.value.map(item => item.cost))
        })
        const minDailyCost = computed(() => {
            return Math.min.apply(null, dataOfThisMonth.value.map(item => item.cost))
        })
        const costOfAfterThisMonth = computed(() => {
            return data.value.filter(item => item.date.indexOf(month.value) < 0).map(item => item.cost).reduce((a, b) => a + b, 0)
        })
        const getAccumulatedCost = (nodeIdx) => {
            return dataOfThisMonth.value.map(item => item.cost).filter((item, itemIdx) => itemIdx <= nodeIdx).reduce((a, b) => a + b)
        }
        const cumalativeCosts = computed(() => {
            return dataOfThisMonth.value.map((item, itemIdx) => {
                return getAccumulatedCost(itemIdx)
            })
        })
        const minCumaltaiveCost = computed(() => {
            return Math.min(Math.min(...cumalativeCosts.value), 0)
        })
        const maxCumaltaiveCost = computed(() => {
            return Math.max(...cumalativeCosts.value)
        })
        const xScale = computed(() => d3.scaleBand().domain(datesOfThisMonth.value).range([svg.value.paddingL, svg.value.width - svg.value.paddingR]).padding([0]))
        const yScale = computed(() => d3.scaleLinear().domain([Math.min(minDailyCost.value, 0), maxDailyCost.value]).nice().range([svg.value.height - svg.value.paddingB, svg.value.paddingT]))
        const yCumaltiveScale = computed(() => d3.scaleLinear().domain([Math.min(minCumaltaiveCost.value, 0), maxCumaltaiveCost.value]).nice().range([svg.value.height - svg.value.paddingB, svg.value.paddingT]))
        const yAxisList = computed(() => {
            if (minDailyCost.value < 0) {
                if (Math.abs(yScale.value(0) - yScale.value(maxDailyCost.value)) < 10) {
                    return [minDailyCost.value, 0]
                } else if (Math.abs(yScale.value(0) - yScale.value(minDailyCost.value)) < 10) {
                    return [0, maxDailyCost.value]
                } else {
                    return [minDailyCost.value, 0, maxDailyCost.value]
                }
            } else {
                return [0, maxDailyCost.value / 2, maxDailyCost.value]
            }
        })
        const mouseoverDate = (date, product) => {
            dateMouseover.value = date
            productMouseover.value = product
        }
        const mouseoutDate = () => {
            dateMouseover.value = null
            productMouseover.value = null
        }

        const emitHandleResize = () => context.emit('resize:svg')
        const emitDetailLayer = date => context.emit('detail-layer', date)
        onMounted(() => {
            window.addEventListener('resize', emitHandleResize)
            vm.$nextTick(() => {
                emitHandleResize()
            })
        })
        onUnmounted(() => {
            window.removeEventListener('resize', emitHandleResize)
        })
        return {
            dateMouseover,
            __toKFormat,
            themeColors,
            theme,
            datesOfThisMonth,
            maxCumaltaiveCost,
            costOfAfterThisMonth,
            cumalativeCosts,
            xScale,
            yScale,
            yCumaltiveScale,
            yAxisList,
            mouseoverDate,
            mouseoutDate,
            emitDetailLayer,
            formattedDate,
            lang
        }
    }
}
</script>

<style>

</style>
